
import { GspModuleState } from './types';

export const state = (): GspModuleState => initialState();

export const initialState = (): GspModuleState => ({
  allGspModules: [], // full raw cache, never filtered/paginated
  allGspModulesCache: {
    lastFetchTime: null,
    isValid: false,
  },
  modulesGrouped: [],
  modulesGroupedCache: {
    data: [],
    lastFetchTime: null,
    isValid: false,
  },
  gspModules: {
    //TODO remove when was made backend
    items: [],
    isLoading: undefined,
    total: 2, //TODO remove when was made backend
    searchParams: {
      dataOption: {
        page: 1,
        itemsPerPage: 25,
        sortBy: [],
        sortDesc: [false],
        groupBy: [],
        groupDesc: [],
        multiSort: true,
        mustSort: false,
      },
      filter: '',
      orClauseFieldsIds: ['name'],
      andClauseFieldsIds: [],
    },
  },

});
